import { atom } from "recoil";

export const muiThemeMode = atom({
  key: "mui.ThemeMode",
  default: "light",
});
